<template lang="pug">
    v-btn( :icon='label ? false : true' :href='`https://wa.me/?text=${mensaje}`' target='_blanck' )
      v-icon fab fa-whatsapp
      span.ml-3(v-if='label') {{label}} 
</template>
<script>
import { mapState } from 'vuex'
export default {
  data: ()=>({
    host:window.location.host
  }),
  computed:{
    mensaje(){
      if(this.cotizacion) return `${this.formatear_espacios(this.texto)} ${this.host}/${this.db}/cotizar/${this.id}/${this.idCotizacion}`
      else return `${this.formatear_espacios(this.texto)} ${this.host}/${this.db}/Orden_de_compra/${this.id}`
    },
    ...mapState({
      db: state => state.Customers.data.slug
    }),
  },
  methods:{
    formatear_espacios: (mensaje)=>{
      mensaje = mensaje.replace(/ /g, '%20')
      return mensaje
    }
  },
  props: {
    id: String,
    texto: String,
    label: String,
    telefono: String,
    cotizacion: Boolean,
    idCotizacion: String
  },

}
</script>